import { render, staticRenderFns } from "./dragDrop.vue?vue&type=template&id=1fd6173c&"
import script from "./dragDrop.vue?vue&type=script&lang=js&"
export * from "./dragDrop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports